import * as React from 'react';
import { AppContext, IFormStateBase } from '../Types/Intyg.types';
import Heading from '../FormSections/Heading';
import YrkeMedAntal from '../FormSections/YrkeMedAntal';
import MainBody from '../FormSections/MainBody';
import FormDivider from '../FormSections/FormDivider';
import PersonuppgifterEjRegleratYrke from '../FormSections/PersonuppgifterEjReglaratYrke';
import SubmitButton from '../FormSections/SubmitButton';
import { FormBase } from '../Types/FormBase';
import { Section } from '../Types/Intyg.enums';
import SprakForIntyget from '../FormSections/SprakForIntyget';

export interface IEjRegleratYrkeProps {}

export interface IEjRegleratYrkeState extends IFormStateBase {}

export default class EjRegleratYrke extends FormBase<IEjRegleratYrkeProps, IEjRegleratYrkeState> {
  private _yrkeMedAntal: React.RefObject<YrkeMedAntal>;
  private _personUppgifter: React.RefObject<PersonuppgifterEjRegleratYrke>;

  constructor(props: IEjRegleratYrkeProps) {
    super(props);

    this._yrkeMedAntal = React.createRef();
    this._personUppgifter = React.createRef();

    this.sectionRefMap.set(Section.YrkeMedAntal, this._yrkeMedAntal);
    this.sectionRefMap.set(Section.PersonuppgifterEjRegleratYrke, this._personUppgifter);

    this.state = { isFormValid: false };
  }

  static contextType = AppContext;

  public render() {
    return (
      <div>
        <Heading />
        <MainBody />
        <FormDivider />
        <YrkeMedAntal ref={this._yrkeMedAntal} />
        <FormDivider />
        <FormDivider />
        <PersonuppgifterEjRegleratYrke ref={this._personUppgifter} />
        <FormDivider />
        <SubmitButton isEnabled={this.state.isFormValid} />
      </div>
    );
  }
}
